import { ref, computed, watch } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment-timezone";
import store from "@/store";
import ability from "@/libs/acl/ability";
import { debounce } from "lodash";

export default function useList() {
  const refListTable = ref(null);
  const toast = useToast();
  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])
  const tenantFilter = ref(null)

  store.dispatch('tenant/getAll')

  store.dispatch('type_alarm/getAll')
  const typeAlarmsOptions = computed(() =>
    store.getters['type_alarm/getSelectedItems'].map(item => ({
      id: item.value,
      name: item.label
    }))
  );

  const tableColumns = [
    { label: "omnicloud_fr.watch_list.name", key: "name", sortable: true },
    { label: "omnicloud_fr.watch_list.comment", key: "comment", sortable: true },
    { label: 'omnicloud_fr.watch_list.color', key: 'color', sortable: true },
    {
      label: 'omnicloud_fr.watch_list.type_alarm',
      key: 'alarm_type',
      sortable: true,
      formatter: (value, key, item) => {
        const alarmType = typeAlarmsOptions.value.find(type => type.id === item.alarm_type);
        return alarmType ? alarmType.name : value || '-';
      }
    },
    {
      label: 'tenants.title',
      key: 'id_tenant',
      sortable: true,
      formatter: (value, key, item) => {
        const tenant = tenantOptions.value.find(t => t.value === item.id_tenant);
        return tenant ? tenant.label : value || '-';
      }
    },
    {
      label: 'omnicloud_fr.is_blacklist',
      key: 'is_blacklist',
      sortable: true
    },
  ];
  if (
    ability.can("update", "OmnicloudFrList") == true ||
    ability.can("delete", "OmnicloudFrList") == true
  ) {
    tableColumns.splice(0, 0, { label: "actions.name", key: "actions" });
  }

  const perPage = ref(10);
  const totalList = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    };
  });

  const fetchList = (ctx, callback) => {
    store
      .dispatch("omnicloud_watch_list/getAll", {
        q: searchQuery.value,
        max: perPage.value,
        "page[n]": currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        callback(response.data);
        totalList.value = response.meta.total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error obteniendo la información",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const formatDateAssigned = (value) => {
    const formattedDate = moment(value).format("DD/MM/YYYY HH:mm:ss");
    return formattedDate;
  };

  const refetchData = () => {
    refListTable.value.refresh();
  };

  watch([
    currentPage,
    perPage,
  ], () => {
    refetchData();
  });

  watch([ searchQuery ], debounce(() => { refetchData() }, 500))

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    tenantOptions,
    refetchData,
    typeAlarmsOptions,
  };
}
